<header class="app-header">
  <div class="toolbar">
    <div class="title-container">
      <h2>Privacy Policy</h2>
    </div>
    <div class="button-container">
      <button class="nav-button" (click)="navigateBack()">BACK</button>
    </div>
  </div>
</header>

<main class="content-container">
  <div class="privacy-container">

    <section class="privacy-section">
      <h2>Introduction</h2>
      <p>This Privacy Policy explains how we collect, use, process, and protect your personal information in accordance
        with the General Data Protection Regulation (GDPR) and other applicable data protection laws.</p>
    </section>

    <section class="privacy-section">
      <h2>Data Controller</h2>
      <p>The UAV Leasing Company, Ltd. is the Data Controller of your personal information. We can be contacted
        at:</p>
      <ul>
        <li>Email: {{contactEmail}}</li>
        <li>Address: {{companyAddress}}</li>
      </ul>
    </section>

    <section class="privacy-section">
      <h2>Information We Collect</h2>
      <p>We collect and process the following types of personal data:</p>

      <h3>Information you provide directly:</h3>
      <ul>
        <li>Communication preferences</li>
        <li>Payment information when applicable</li>
      </ul>

      <h3>Information collected automatically:</h3>
      <ul>
        <li>IP address</li>
        <li>Device information</li>
        <li>Cookies and similar technologies</li>
        <li>Usage data and analytics</li>
      </ul>
    </section>

    <section class="privacy-section">
      <h2>Legal Basis for Processing</h2>
      <p>We process your personal data under the following legal bases:</p>
      <ul>
        <li><strong>Contractual Necessity:</strong> To fulfill our contractual obligations to you</li>
        <li><strong>Legal Obligation:</strong> To comply with applicable laws</li>
        <li><strong>Legitimate Interests:</strong> To provide and improve our services</li>
      </ul>
    </section>

    <section class="privacy-section">
      <h2>Your Rights Under GDPR</h2>
      <p>You have the following rights regarding your personal data:</p>
      <ol>
        <li>Right to be informed about the collection and use of your data</li>
        <li>Right to access your personal data</li>
        <li>Right to rectification if your data is inaccurate or incomplete</li>
        <li>Right to erasure ("right to be forgotten")</li>
        <li>Right to restrict processing</li>
        <li>Right to data portability</li>
        <li>Right to object to processing</li>
        <li>Rights related to automated decision making and profiling</li>
      </ol>
    </section>

    <section class="privacy-section">
      <h2>Cookie Policy</h2>
      <p>We use cookies and similar tracking technologies to enhance your experience. You can control cookie preferences
        through your browser settings. Types of cookies we use:</p>
      <ul>
        <li>Essential cookies</li>
        <li>Functional cookies</li>
        <li>Analytics cookies</li>
        <li>Marketing cookies (with consent)</li>
      </ul>
    </section>

    <section class="privacy-section">
      <h2>Data Security</h2>
      <p>We implement appropriate technical and organizational measures to protect your personal data against
        unauthorized access, alteration, disclosure, or destruction.</p>
    </section>

    <section class="privacy-section">
      <h2>International Data Transfers</h2>
      <p>If we transfer your data outside the European Economic Area (EEA), we ensure adequate safeguards are in place
        in
        accordance with GDPR requirements.</p>
    </section>

    <section class="privacy-section">
      <h2>Data Retention</h2>
      <p>We retain your personal data only for as long as necessary to fulfill the purposes for which it was collected,
        or
        as required by applicable laws and regulations.</p>
    </section>

    <section class="privacy-section">
      <h2>Changes to This Policy</h2>
      <p>We may update this Privacy Policy from time to time. We will notify you of any material changes by posting the
        new policy on our website.</p>
    </section>

    <section class="privacy-section">
      <h2>Contact Us</h2>
      <p>For any questions about this Privacy Policy or our data practices, please contact our Data Protection Officer
        at:
      </p>
      <ul>
        <li>Email: {{dpoEmail}}</li>
        <li>Phone: {{phoneNumber}}</li>
      </ul>
    </section>

    <section class="privacy-section">
      <h2>Complaints</h2>
      <p>You have the right to lodge a complaint with your local data protection authority if you believe we have not
        handled your personal data in accordance with applicable laws.</p>
    </section>

    <section class="privacy-section">
      <h2>Current Cookies</h2>
      <div class="cookies-list">
        <div class="cookie-item" *ngFor="let cookie of cookies | keyvalue">
          <div class="cookie-info">
            <h3>{{cookie.key}}</h3>
            <p>Value: {{cookie.value}}</p>
          </div>
          <button class="delete-button" (click)="deleteSingleCookie(cookie.key)">
            <span class="delete-icon">🗑</span>
          </button>
        </div>

        <div class="cookie-actions">
          <button class="clear-all-button" (click)="clearAllCookies()">
            Clear All Cookies
          </button>
        </div>
      </div>
    </section>

    <footer class="privacy-footer">
      <p>Last updated: 25/07/2026</p>
    </footer>
  </div>
</main>